var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00879 1L13.991 13M11.3699 10.5669C10.3569 11.1134 9.21204 11.4999 7.99989 11.4999C5.35583 11.4999 3.03204 9.66085 1.69944 8.3341C1.34768 7.98393 1.17184 7.8088 1.05989 7.46508C0.980049 7.21998 0.980026 6.77995 1.05989 6.53477C1.17187 6.19112 1.34808 6.01562 1.70054 5.66477C2.3722 4.99616 3.29547 4.19769 4.38449 3.57007M13.6165 8.97513C13.8659 8.75538 14.0944 8.53923 14.2994 8.33523L14.3016 8.3329C14.6525 7.98355 14.8285 7.80842 14.9402 7.46545C15.02 7.22035 15.0199 6.7801 14.9401 6.535C14.8282 6.19143 14.6521 6.01577 14.3006 5.66582C12.9679 4.33906 10.6439 2.5 7.99989 2.5C7.74715 2.5 7.49732 2.51681 7.25101 2.54836M8.9906 8.125C8.72654 8.3584 8.37973 8.5 7.99989 8.5C7.17267 8.5 6.50211 7.82845 6.50211 7C6.50211 6.59538 6.66208 6.22833 6.92217 5.95848",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditHide);
export default __webpack_public_path__ + "static/media/edit--hide.e2f0ebde2771048413122c9c08ad2d89.svg";
export { ForwardRef as ReactComponent };